import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { POLICY_SECTIONS } from "../data/policies";
import "./Policies.css";

/** "#privacy" -> the privacy section; unknown or empty hash -> the first section. */
export function sectionForHash(hash) {
  const key = decodeURIComponent(String(hash || "").replace(/^#/, ""));
  return POLICY_SECTIONS.find(p => p.key === key) || POLICY_SECTIONS[0];
}

export default function Policies() {
  // The URL hash is the source of truth, so /policies#privacy is shareable and
  // in-app <Link to="/policies#terms"> switches the tab on the same page.
  const { hash } = useLocation();
  const navigate = useNavigate();
  const current = sectionForHash(hash);

  return (
    // id = active key: Layout scrolls to the element matching the hash.
    <section className="section white" id={current.key}>
      <div className="container">
        <h1>Policies</h1>
        <p className="muted">Transparency and trust in how I operate.</p>

        <div className="two-col" style={{marginTop:"1rem"}}>
          <nav className="side-nav sticky" aria-label="Policies">
            {POLICY_SECTIONS.map(sec => (
              <button
                type="button"
                key={sec.key}
                className={`side-link ${current.key === sec.key ? "active" : ""}`}
                aria-current={current.key === sec.key ? "page" : undefined}
                aria-controls="policy-panel"
                onClick={() => navigate({ hash: `#${sec.key}` })}
              >
                {sec.label}
              </button>
            ))}
          </nav>

          <article id="policy-panel" className="content-panel" aria-labelledby="policy-panel-heading">
            <h2 id="policy-panel-heading" className="policy-title">{current.label}</h2>
            <div className="policy-content policy-body">{current.content}</div>
          </article>
        </div>
      </div>
    </section>
  );
}
